const comments = [
  {
    name: '吃瓜小能手',
    role: '资深瓜友',
    text: '51吃瓜网真的太快了！每次有大事件发生，我第一时间打开这里就能看到最新进展。不愧是吃瓜爆料第一站，已经推荐给身边所有爱八卦的姐妹了！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20studio%20lighting%2C%20neutral%20warm%20background%2C%20modern%20casual%20style%2C%20natural%20expression&width=120&height=120&seq=avatar-user-01&orientation=squarish'
  },
  {
    name: '八卦研究员',
    role: '认证瓜友',
    text: '内容太全了，明星八卦、网红翻车、综艺争议全都有。而且排版清晰，刷起来特别舒服。现在每天刷51吃瓜网已经成习惯了，比刷微博还有意思。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%20with%20friendly%20expression%2C%20clean%20studio%20lighting%2C%20neutral%20warm%20background%2C%20modern%20casual%20style%2C%20natural%20look&width=120&height=120&seq=avatar-user-02&orientation=squarish'
  },
  {
    name: '追瓜不停歇',
    role: '铁杆瓜粉',
    text: 'APP做得太好了，推送及时不骚扰，夜间模式看瓜太舒服了。独家爆料质量很高，很多内容别的地方都看不到，51吃瓜网yyds！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20stylish%20young%20Chinese%20woman%2C%20warm%20genuine%20smile%2C%20clean%20studio%20lighting%2C%20neutral%20warm%20background%2C%20modern%20fashion%20look&width=120&height=120&seq=avatar-user-03&orientation=squarish'
  },
  {
    name: '社会观察家',
    role: '深度用户',
    text: '之前一直找不到靠谱的吃瓜平台，自从发现51吃瓜网就离不开了。信息更新快、来源标注清楚、评论区氛围也好。强烈推荐给所有爱吃瓜的朋友！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20mature%20Chinese%20man%20with%20thoughtful%20expression%2C%20clean%20studio%20lighting%2C%20neutral%20warm%20background%2C%20business%20casual%20style&width=120&height=120&seq=avatar-user-04&orientation=squarish'
  },
  {
    name: '娱乐先锋报',
    role: '媒体人',
    text: '作为媒体从业者，51吃瓜网的信息聚合能力让我很佩服。热点追踪又快又准，内容筛选也很有水准，已经是我们团队的重要信息源之一。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20confident%20Chinese%20woman%20in%20media%20industry%2C%20warm%20professional%20expression%2C%20clean%20studio%20lighting%2C%20neutral%20warm%20background%2C%20modern%20professional%20style&width=120&height=120&seq=avatar-user-05&orientation=squarish'
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-primary-600 bg-primary-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            用户评价
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">瓜友热评</h2>
          <p className="text-sm text-foreground-500 mt-3">听听吃瓜群众们怎么说</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.slice(0, 3).map((comment, i) => (
            <div key={i} className="bg-background-50 rounded-2xl p-6 border border-background-200/70 hover:border-accent-200 transition-all duration-300">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.role}</div>
                </div>
              </div>
              <div className="text-accent-300 text-3xl leading-none mb-2 font-heading">&ldquo;</div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {comments.slice(3).map((comment, i) => (
              <div key={i + 3} className="bg-background-50 rounded-2xl p-6 border border-background-200/70 hover:border-accent-200 transition-all duration-300">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                    <div className="text-xs text-foreground-500">{comment.role}</div>
                  </div>
                </div>
                <div className="text-accent-300 text-3xl leading-none mb-2 font-heading">&ldquo;</div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}